module.exports = __webpack_public_path__ + "img/excel.e37161b0.png";